import { useEffect } from "react"

export function useDisableOverflowBehavior() {
    useEffect(() => {
        // Disable overscroll behavior on booking page
        document.body.style.overscrollBehavior = "none"
        return () => {
            document.body.style.overscrollBehavior = "initial"
        }
    }, [])
}
